"use strict";
exports.__esModule = true;
exports.fromHex = exports.toHex = void 0;
function toHex(data, prefix) {
    if (prefix === void 0) { prefix = false; }
    var encoded = data.reduce(function (str, byte) { return str + byte.toString(16).padStart(2, '0'); }, '');
    return prefix ? '0x' + encoded : encoded;
}
exports.toHex = toHex;
function fromHex(data) {
    if (data === '' || data === null || data === undefined) {
        return new Uint8Array();
    }
    if (data.length % 2 !== 0) {
        throw new Error('invalid data size');
    }
    if (data.indexOf('0x') === 0) {
        data = data.substring(2);
    }
    return new Uint8Array(data.match(/.{1,2}/g).map(function (byte) { return parseInt(byte, 16); }));
}
exports.fromHex = fromHex;
